import type { Tab } from '@/config/apps.config';

/**
 * EPIC-022 S022.1 (AC 18/19) — staat de voorraad van de hersteller van deze sessie in CARculate?
 *
 * De ENE lezer van whoami `inventoryInCarculate` in de FE. Fail-closed op `=== true`: een whoami zonder het veld (oude
 * BE, gemockte payload) telt als uit. Een menu-hint: de autoriteit is de poort van `api/inventory/warehouses`.
 *
 * Staat in `src/auth/` (niet in een feature-map): de tab-strip en de route-guard lezen hem.
 */
export function isInventoryInCarculate(user: { inventoryInCarculate?: boolean | null } | null | undefined): boolean {
    return user?.inventoryInCarculate === true;
}

/**
 * De klikbaarheid van een tab: `enabled` uit `apps.config.ts`, plus de tab Inkoop → Voorraad zodra de voorraad in
 * CARculate staat (`enabledWhenInventoryInCarculate`). Voor ieder ander blijft de tab exact zoals in de config
 * ("Binnenkort"). Puur; verandert de config niet.
 */
export function effectiveTabEnabled(tab: Tab, inventoryInCarculate: boolean): boolean {
    return tab.enabled || (tab.enabledWhenInventoryInCarculate === true && inventoryInCarculate);
}

/** De route van Inkoop → Voorraad en het eerste scherm (S022.1: magazijnen en locaties; S022.2 zet daar het overzicht). */
export const INVENTORY_ROUTE = '/inkoop/voorraad';
export const INVENTORY_WAREHOUSES_ROUTE = '/inkoop/voorraad/magazijnen';
/** Waar een ingetypt adres onder `/inkoop/voorraad` heen gaat zonder voorraad in CARculate. */
export const INVENTORY_FALLBACK_ROUTE = '/inkoop/bestellijst';
